/* eslint no-console: "off" */
import { serializeError } from 'serialize-error';
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["TRACE"] = "TRACE";
})(LogLevel || (LogLevel = {}));
export const getLogLevel = (levelString) => {
    switch (levelString.toLowerCase()) {
        case 'debug':
            return LogLevel.DEBUG;
        case 'info':
            return LogLevel.INFO;
        case 'warn':
            return LogLevel.WARN;
        case 'error':
            return LogLevel.ERROR;
        case 'trace':
            return LogLevel.TRACE;
        default:
            throw new Error(`Unsupported log level value: ${levelString}`);
    }
};
export class Logger {
    static Instance(params = {}) {
        if (Logger.instance == null) {
            Logger.instance = new Logger(params);
        }
        return Logger.instance;
    }
    constructor({ logLevelBoundary: level = LogLevel.INFO } = {}) {
        this.logLevelBoundary = level;
    }
    raw(message) {
        console.log(message);
    }
    debug(message, ...args) {
        this.logMessage(LogLevel.DEBUG, message, ...args);
    }
    info(message, ...args) {
        this.logMessage(LogLevel.INFO, message, ...args);
    }
    warn(message, ...args) {
        this.logMessage(LogLevel.WARN, message, ...args);
    }
    error(message, ...args) {
        this.logMessage(LogLevel.ERROR, message, ...args);
    }
    trace(message, ...args) {
        this.logMessage(LogLevel.TRACE, message, ...args);
    }
    logLevelIndex(level) {
        switch (level) {
            case LogLevel.TRACE:
                return 1;
            case LogLevel.DEBUG:
                return 2;
            case LogLevel.INFO:
                return 3;
            case LogLevel.WARN:
                return 4;
            case LogLevel.ERROR:
                return 5;
            default:
                throw new Error(`Unsupported log level: ${level}`);
        }
    }
    skipLogMessage(level) {
        return this.logLevelIndex(level) < this.logLevelIndex(this.logLevelBoundary);
    }
    logMessage(level, message, ...args) {
        if (this.skipLogMessage(level)) {
            return;
        }
        const logObject = JSON.stringify({
            level,
            message: typeof message === 'string' ? message.trim() : message,
            timestamp: new Date().toISOString(),
            details: args.map(arg => (arg instanceof Error ? serializeError(arg) : arg))
        });
        switch (level) {
            case LogLevel.DEBUG:
                console.debug(logObject);
                break;
            case LogLevel.INFO:
                console.info(logObject);
                break;
            case LogLevel.WARN:
                console.warn(logObject);
                break;
            case LogLevel.ERROR:
                console.error(logObject);
                break;
            case LogLevel.TRACE:
                console.trace(logObject);
                break;
            default:
                throw Error(`log level ${level} not supported!`);
        }
    }
}
export const logger = Logger.Instance();
//# sourceMappingURL=logger.js.map